(function ($) {
    $(".product-files-download-form").on("submit_success", function(){
        $(this).trigger("reset")
    })
})(jQuery);